import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';

const LoginAuthentication = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      navigate('/dashboard-overview', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'Vazirmatn, sans-serif',
            direction: 'rtl',
          },
        }}
      />
      <div className="w-full max-w-md">
        {/* Main Login Card */}
        <div className="bg-card rounded-2xl shadow-lg border border-border p-8">
          <LoginHeader />
          <LoginForm />
        </div>

        {/* Footer Information */}
        <div className="mt-8 text-center space-y-4">
          <div className="bg-card/50 rounded-lg p-4 border border-border/50">
            <h3 className="font-semibold text-foreground mb-2">
              اطلاعات تست (برای توسعه‌دهندگان)
            </h3>
            <div className="text-sm text-muted-foreground space-y-1">
              <p>
                شماره موبایل:{' '}
                <span className="font-mono">+98 912 000 0000</span>
              </p>
              <p>
                کد تأیید: <span className="font-mono">123456</span>
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground">
            <button className="hover:text-primary transition-colors">
              راهنما
            </button>
            <span>•</span>
            <button className="hover:text-primary transition-colors">
              پشتیبانی
            </button>
            <span>•</span>
            <button className="hover:text-primary transition-colors">
              حریم خصوصی
            </button>
          </div>

          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} ایران‌داد. تمامی حقوق محفوظ است.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginAuthentication;
